export { default, getServerSideProps } from './JobDetailPage';
